module.exports = __webpack_public_path__ + "static/temilola-ae95d8bbb6b880586b388a2531dc62d1.jpg";